import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { invoiceReminderFeeWrittenOff } from "store/actions/invoiceActions";
//#endregion
//#region types
import { StyleEnums } from "models/enums";
import { ReminderFeeNotPaidBannerProps } from "models/propTypes/invoicePropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { Banner, GridR, StyledButton, useCheckRelations } from "components/common";
import { Box, Grid } from "@mui/material";
import useWriteOffReminderFeeDialog from "components/invoice/actions/useWriteOffReminderFeeDialog";
import { useInvoiceService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const ReminderFeeNotPaidBanner: React.FC<ReminderFeeNotPaidBannerProps> = (props) => {
  const invoiceService = useInvoiceService();
  const { invoice, reloadHandler } = props;
  const dispatch = useDispatch();
  const { showWriteOffReminderFeeDialog } = useWriteOffReminderFeeDialog();

  const remainingAmount = LocalizationHelperInstance.getFormattedCurrency(invoice.leftToPay ?? 0, invoice.currency);

  const onWriteOffClick = () => {
    showWriteOffReminderFeeDialog(remainingAmount, async () => {
      await invoiceService.writeOffReminderFee(invoice.id);
      dispatch(invoiceReminderFeeWrittenOff(invoice.id));
      reloadHandler && reloadHandler();
    });
  };

  const { getIsReadonlyUser } = useCheckRelations();

  if (getIsReadonlyUser()) {
    return <></>;
  }

  return (
    <Banner
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.ReminderFeeNotPaidHeader)}
      icon={IconDefinitionConstants.WBell}
      type={StyleEnums.DisplayType.Warning}
    >
      <GridR container direction="column" spacing={3}>
        <Grid item>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.ReminderFeeNotPaidBannerText, "", {
            amount: remainingAmount,
          })}
        </Grid>
        <Grid item>
          <Box m={1} component="span">
            <StyledButton size="sm" displayType={StyleEnums.DisplayType.Warning} onClick={onWriteOffClick}>
              {`${LocalizationHelperInstance.getFormattedMessage(
                TranslationKeys.Invoice.WriteOffReminderFee
              )} ${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.Fee).toLowerCase()}`}
            </StyledButton>
          </Box>
        </Grid>
      </GridR>
    </Banner>
  );
};

export default ReminderFeeNotPaidBanner;
